import {useMutation} from '@tanstack/react-query'
import {useDeleteBookingApiMethod} from 'api/useDeleteBookingApiMethod'
import {useGetOrderApiMethod} from 'api/useGetOrderApiMethod'

type Params = {
  bookingUuid: string
  orderId: string
}

export const useDeleteBookingMutation = () => {
  const getOrder = useGetOrderApiMethod()
  const deleteBooking = useDeleteBookingApiMethod()

  return useMutation({
    mutationFn: async ({bookingUuid, orderId}: Params) => {
      await deleteBooking(bookingUuid)
      return await getOrder(orderId)
    },
  })
}
